import { Logo } from '@/components/ui/Logo'
import { cn } from '@/lib/cn'

/**
 * The «Aivy» lockup: the mark and the wordmark in the display role (Onest 700). The only place
 * the display role is allowed in the admin (design §3.1, WP-06): the rail, the phone top bar and
 * the login screen. Headings everywhere else are Onest 600 (`title-1` / `title-2`).
 */
export function BrandLockup({ size = 26, className }: { size?: number; className?: string }) {
  return (
    <div className={cn('season-brand inline-flex items-center gap-2 font-display text-title-2 font-bold text-ink-1', className)}>
      <Logo size={size} />
      Aivy
    </div>
  )
}
